import dayjs from "dayjs";
import type {
  FundExceptionAction,
  FundExceptionItem,
  FundExceptionStatus,
  FundExceptionType,
} from "../../api/fund-exceptions.api";

export const EXCEPTION_TYPE_LABEL: Record<FundExceptionType, string> = {
  LOST_PAYMENT: "掉单",
  LATE_PAYMENT: "超时后到账",
  DUPLICATE_PAYMENT: "重复支付",
  AMOUNT_MISMATCH: "金额不符",
  PAID_NOT_ENTITLED: "已支付未开通",
  OWNERSHIP_ANOMALY: "归属异常",
};

export const RECOMMENDED_ACTION_LABEL: Record<
  FundExceptionItem["recommendedAction"],
  string
> = {
  GRANT_ENTITLEMENT: "补开课时",
  REFUND: "原路退回",
  CORRECT_AMOUNT: "金额纠正",
  REVERSE_ENTITLEMENT: "课时冲正",
  RETRY: "重试",
  CLOSE: "关闭异常",
};

export const STATUS_META: Record<
  FundExceptionStatus,
  { label: string; color: string }
> = {
  PENDING: { label: "待处理", color: "orange" },
  PROCESSING: { label: "处理中", color: "blue" },
  CLOSED: { label: "已关闭", color: "default" },
  FAILED: { label: "处理失败", color: "red" },
};

export const LOCAL_STATUS_LABEL: Record<string, string> = {
  NONE: "无本地记录",
  SUCCEEDED: "已成功",
  FAILED: "已失败",
  RECEIVED: "已接收待处理",
  PENDING_PAYMENT: "待支付",
  PARTIALLY_PAID: "部分支付",
  PAID: "已支付",
  CANCELLED: "已取消",
  EXPIRED: "已过期",
};

export const ACTION_RESULT_LABEL: Record<
  FundExceptionAction["result"],
  string
> = {
  SUCCEEDED: "成功",
  FAILED: "失败",
  REJECTED: "已拒绝",
};

export function formatDateTime(value: string | null): string {
  return value ? dayjs(value).format("YYYY-MM-DD HH:mm") : "-";
}

export function exceptionTypeLabel(value: FundExceptionType): string {
  return EXCEPTION_TYPE_LABEL[value] ?? value;
}

export function recommendedActionLabel(
  value: FundExceptionItem["recommendedAction"],
): string {
  return RECOMMENDED_ACTION_LABEL[value] ?? value;
}

export function localStatusLabel(value: string): string {
  return LOCAL_STATUS_LABEL[value] ?? value;
}

/** 列表无独立契约字段时从异常类型与本地状态投影课时开通状态，详情再以原始事件状态复核。 */
export function entitlementStatusLabel(item: FundExceptionItem): string {
  if (item.localStatus === "SUCCEEDED") return "已开通";
  if (item.localStatus === "FAILED") return "开通失败";
  if (item.localStatus === "RECEIVED") return "待确认";
  if (
    item.exceptionType === "LOST_PAYMENT" ||
    item.exceptionType === "PAID_NOT_ENTITLED"
  ) {
    return "未开通";
  }
  return "待确认";
}

export function actionValueText(value: Record<string, unknown> | null): string {
  return value ? JSON.stringify(value) : "-";
}
